import _ from 'lodash'
import { exportCsv } from './exportCsv'

export const exportFullCsv = (
  rawData = [],
  ignoredColumns = [],
  { callback = null, fileName = 'export.csv' } = {}
) => {
  if (rawData.length === 0) {
    return
  }

  const columnNames = Object.keys(rawData[0]).filter(
    key => !ignoredColumns.includes(key)
  )
  const data = rawData.map(row => Object.values(_.pick(row, columnNames)))

  exportCsv(data, {
    columnNames,
    fileName
  })

  if (callback) {
    callback()
  }
}
